import axios from 'axios'
import { CartItem } from './validate'

interface AlgoliaAttributes {
  sku: string
  queryID: string | null | undefined
  indexName: string | null | undefined
  userToken: string | null | undefined
  authenticatedUserToken: string | null | undefined
}

const getAlgoliaAttributes = (item: CartItem): AlgoliaAttributes => {
  return {
    sku: item.itemOffered.sku,
    queryID: item.itemOffered.queryID,
    indexName: item.itemOffered.indexName,
    userToken: item.itemOffered.userToken,
    authenticatedUserToken: item.itemOffered.authenticatedUserToken,
  }
}

export const updateOrderForm = async (items: CartItem[], cartId: string) => {
  const initialAlgoliaAttributes: Array<AlgoliaAttributes> = []

  items.forEach((item: CartItem) =>
    initialAlgoliaAttributes.push(getAlgoliaAttributes(item))
  )

  const algoliaAttributesStringified = JSON.stringify(initialAlgoliaAttributes)

  await axios.post('/api/checkout/updateOrderForm', {
    orderFormId: cartId,
    appId: 'arcaplanetskuattributes',
    algoliaAttributes: algoliaAttributesStringified,
  })
}
